<template>
	<div class="step-form">
		<div class="form-row">
			<div class="form-row__item container--title-input">
				<label v-bind:for="stepHtmlId" class="title-input step__title-input--prefix">Step {{activeStepIndex + 1}}:&nbsp;</label>
				<input v-bind:id="stepHtmlId" class="title-input step__title-input" type="text" v-model="activeStep.title" placeholder="Title (optional)" :maxlength="titleMaxLength" spellcheck="true">
			</div>
		</div>
		<div class="form-row">
			<div class="form-row__item">
				<Editor v-model="activeStep.content" />
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapGetters } from 'vuex'
	import Editor from './Editor'

	export default {
		name: 'step-form',
		components: {
			Editor
		},
		data: function () {
			return {
				titleMaxLength: Grabcad.AttributeLimits.Generic.TITLE,
			}
		},
		computed: {
			...mapState(['activeStep', 'tutorial']),
			...mapGetters(['activeStepIndex']),
			stepHtmlId () {
				return `step-${this.activeStepIndex}`
			}
		},
		mounted () { }
	}
</script>

<style lang="scss">
	@import "@/styles/tutorial_editor/globals";
	.step-form {
		padding-left: 36px;
		padding-right: 36px;
	}

	.step__title-input {
		font-family: $font-family;
		flex: 1 0 auto;

		&--prefix {
			width: auto;
			flex: 0 0 auto;
			padding-right: 16px;
			user-select: none;
		}
	}
	.container--title-input {
		display: flex;
		flex-direction: row;
		flex-flow: nowrap;
	}
</style>
